import * as React from "react";
import { forwardRef } from "react";
const SvgRemoveSmall = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 2, y: 7.75, width: 12, height: 1.5, rx: 0.2, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgRemoveSmall);
export { ForwardRef as ReactComponent };
